import { render, staticRenderFns } from "./SetImages.vue?vue&type=template&id=0276f90b"
import script from "./SetImages.vue?vue&type=script&lang=js"
export * from "./SetImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports